export const examinerMap = {
	nome: "name",
};
